var map = {
	"./aave.svg": 586,
	"./bg-waves.svg": 234,
	"./check.svg": 587,
	"./coinbaseWalletIcon.svg": 337,
	"./defisnap.svg": 588,
	"./dydx.svg": 589,
	"./footer/footer-icon-1.svg": 339,
	"./footer/footer-icon-2.svg": 340,
	"./footer/footer-icon-3.svg": 341,
	"./footer/footer-icon-4.svg": 342,
	"./footer/footer-icon-5.svg": 343,
	"./footer/footer-icon-6.svg": 590,
	"./footer/footer-icon-dark-1.svg": 344,
	"./footer/footer-icon-dark-2.svg": 345,
	"./footer/footer-icon-dark-3.svg": 346,
	"./footer/footer-icon-dark-4.svg": 347,
	"./footer/footer-icon-dark-5.svg": 348,
	"./footer/footer-icon-dark-6.svg": 591,
	"./header-beta-icon-dark.svg": 592,
	"./header-beta-icon.svg": 593,
	"./icn-aethereum.svg": 336,
	"./icn-ledger.svg": 197,
	"./icn-metamask.svg": 233,
	"./ico-cover.svg": 349,
	"./ico-darkmode-dark.svg": 594,
	"./ico-darkmode.svg": 595,
	"./ico-dashboard.svg": 350,
	"./ico-deposit.svg": 198,
	"./ico-grow-light.svg": 596,
	"./ico-grow.svg": 597,
	"./ico-save.svg": 351,
	"./ico-wallet-dark.svg": 598,
	"./ico-wallet.svg": 599,
	"./ico-withdraw.svg": 199,
	"./ico-ycosystem.svg": 352,
	"./ico-zapper.svg": 353,
	"./karet-down-dark.svg": 354,
	"./karet-down-light.svg": 355,
	"./lendf.svg": 600,
	"./logo-top-dark.svg": 601,
	"./logo-top.svg": 602,
	"./metamask.svg": 356,
	"./no-check.svg": 603,
	"./oCurve-logo.svg": 604,
	"./oneinch.svg": 605,
	"./uniswap.svg": 606,
	"./walletConnectIcon.svg": 330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;